let _el
export function esc(text) {
  if (!text) return ''
  if (!_el) _el = document.createElement('div')
  _el.textContent = text
  return _el.innerHTML
}

// Attribute context: the textContent trick escapes &<> but NOT quotes, so a
// value interpolated into src="..." could still break out of the attribute.
export function escAttr(text) {
  return esc(text).replaceAll('"', '&quot;').replaceAll("'", '&#39;')
}

/**
 * Return a browser-loadable image URL, rejecting scriptable and opaque schemes.
 */
export function safeImageUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return ''
  try {
    const url = new URL(value, window.location.origin)
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return ''
    return url.href
  } catch {
    return ''
  }
}
